
export enum BookingFlows {
	new = 1,
	rebook,
	urgency,
	select,
	request
}
